<template>
  <div class="py-4 container-fluid">
    <div class="card">
      <div class="card-body">
        <div>
          <h4 style="text-align: center;">{{ sectionTitle }}</h4>
        </div>
        <hr class="horizontal dark" />
        <h5>مشتریان دارای دسترسی</h5>
        <hr class="horizontal dark" />
        <table class="table table-striped table-styled table-sm">
          <tbody>
            <template v-for="(c, index) in currentCustomers">
              <tr v-if="!c.isDeleted">
                <td scope="row">{{ index + 1 }}</td>
                <td style="width: 30%;">{{ c.title }}</td>
                <td style="width: 20%;">{{ c.countryTitle }} - {{ c.provinceTitle }} - {{ c.countyTitle }}</td>
                <td style="width: 35%;">{{ c.parentTitle ? "والد:" : ""}} {{ c.parentTitle }}</td>
                <td style="width: 10%;">
                  <button class="btn btn-sm bg-gradient-danger mb-0" @click="removeCustomer(c)">
                    حذف
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <hr class="horizontal dark" />
        <h5>سایر مشتریان شرکت</h5>
        <hr class="horizontal dark" />
        <div class="col-md-3">
          <label class="form-control-label" for="searchField">جستجو</label>
          <input class="form-control" type="text" id="searchField" name="searchField"
            v-model.trim="searchField" />
          </div>
        <hr class="horizontal dark" />
        <table class="table table-striped table-styled table-sm">
          <tbody>
            <tr v-for="(c, index) in filteredCustomers">
              <td scope="row">{{ index + 1 }}</td>
              <td style="width: 30%;">{{ c.title }}</td>
              <td style="width: 20%;">{{ c.countryTitle }} - {{ c.provinceTitle }} - {{ c.countyTitle }}</td>
              <td style="width: 35%;">{{ c.parentTitle ? "والد:" : ""}} {{ c.parentTitle }}</td>
              <td  style="width: 10%;">
                <button class="btn btn-sm bg-gradient-success mb-0" @click="addCustomer(c)">
                  افزودن
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <hr class="horizontal dark" />
        <button type="button" class="btn bg-gradient-success mb-0" @click="submit()">ثبت تغییرات</button>
        <button class="btn bg-gray-400 me-3 float-start mb-0" type="button" @click="goBack">بازگشت</button>
      </div>
    </div>
  </div>
</template>
<script>
  import CompanyService from '@/services/Company/Company-service.js';
  import CustomerService from '../../services/Company/Customer-service';

  export default {
    data() {
      return {
        sectionId: null,
        sectionTitle: '',
        companyId: null,
        companyTitle: '',
        currentCustomers: [],
        otherCustomers: [],
        searchField: '',
      };
    },
    computed:{
      filteredCustomers(){
        let customers = this.otherCustomers;

        if (this.searchField != "") {
          customers = customers.filter(x => x.searchProp.includes(this.searchField));
        }

        return customers;
      },
    },
    watch: {
      sectionId(sectionId){
        if (sectionId) {
          this.getCurrentCustomers();
        }
      },
    },
    methods: {
      goBack() {
        this.$router.back();
      },
      getCurrentCustomers() {
        CustomerService.getCustomersByCompanySectionId(this.sectionId).then(response => {
          let result = response.data;
          
          if (result.success) {
            this.currentCustomers = result.data.map((customer) => ({ ...customer, isNew: false, isDeleted: false, searchProp: (customer.title + customer.parentTitle) }));
            
            setTimeout(() => this.getCustomersByCompany(), 100);
          }
          else {
            this.$toast.error(result.message);
          }
        }).catch(e => {
          console.log(e);
        });
      },
      getCustomersByCompany() {
        CustomerService.getCustomersByCompanyId(this.companyId).then(response => {
          let result = response.data;

          if (result.success) {
            this.otherCustomers = result.data.map((customer) => ({ ...customer, searchProp: (customer.title + customer.parentTitle) }));
  
            this.currentCustomers.forEach((customer) => {
              let index = this.otherCustomers.map(x => x.id).findIndex((x) => {return x == customer.id; });
              
              if (index > -1) { this.otherCustomers.splice(index, 1) }
            });
          }
          else {
            this.$toast.error(result.message);
          }
        }).catch(e => {
          console.log(e);
        });
      },
      removeCustomer(customer) {
        if (customer.isNew == true) {
          const index = this.currentCustomers.map(x => x.id).indexOf(customer.id);

          if (index > -1) {
            this.currentCustomers.splice(index, 1);
          }
        }
        else {
          customer.isDeleted = true;
        }
        this.otherCustomers.push(customer);
      },
      addCustomer(customer) {
        const index = this.currentCustomers.map(x => x.Id).indexOf(customer.id);

        if (index == -1) {
          this.currentCustomers.push({
            ...customer,
            isNew: true,
            isDeleted: false
          });
        }
        else if (this.currentCustomers[index].isDeleted) {
          this.currentCustomers[index].isDeleted = false;
        }
        let customerIndex = this.otherCustomers.map(x => x.id).indexOf(customer.id);

        this.otherCustomers.splice(customerIndex, 1);
      },
      submit() {
        let vm = {
          CompanySectionId : this.sectionId,
          AddedCustomersIds : this.currentCustomers.filter(x => x.isNew).map(x => x.id),
          RemovedCustomersIds : this.currentCustomers.filter(x => x.isDeleted).map(x => x.id),
        };

        CompanyService.modifyCompanySectionsCustomers(vm).then(response => {
          let result = response.data;

          if (result.success) {
            this.$toast.success(result.message);
            this.goBack();
          }
          else {
            this.$toast.error(result.message);
          }
        }).catch(e => {
          console.log(e);
        });
      },
      goBack() {
        this.$router.back();
      }
    },
    created() {
      this.sectionId = this.$route.query.sectionId;
      this.sectionTitle = this.$route.query.sectionTitle;
      this.companyId = this.$route.query.companyId;
      this.companyTitle = this.$route.query.companyTitle;
    }
  }
</script>
